import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  BarChartIcon,
  BoltIcon,
  Button,
  Card,
  ClockIcon,
  DisabledText,
  Inline,
  Stack,
  SubHeadline,
} from "@KristianIV/common-ui";
import RouteButton from "../../shell/RouteButton";
import { ApplicationState } from "../../reducers";
import { getClockAnalyticsStatus, turnOffClockAnalytics, turnOnClockAnalytics } from "../../services/adminService";

/** Links to the per-device analytics pages, plus the switch for clock-analytics collection. */
const DeviceAnalytics = ({ deviceId }: { deviceId: string }) => {
  const jwtToken = useSelector((state: ApplicationState) => state.organisation.userJwtToken);
  const [clockAnalyticsActive, setClockAnalyticsActive] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (!jwtToken) {
      return;
    }
    getClockAnalyticsStatus(jwtToken, deviceId)
      .then((status) => setClockAnalyticsActive(status.enabled))
      .catch((err) => console.error("Failed to get clock analytics status", err));
  }, [jwtToken, deviceId]);

  const setCollection = (active: boolean) => {
    if (!jwtToken) {
      return;
    }
    const call = active ? turnOnClockAnalytics : turnOffClockAnalytics;
    call(jwtToken, deviceId)
      .then(() => setClockAnalyticsActive(active))
      .catch((err) => console.error("Failed to change clock analytics collection", err));
  };

  return (
    <Card interactive={false} padded>
      <SubHeadline>Analytics</SubHeadline>
      <Stack gap="md" align="start">
        <Inline>
          <RouteButton to={`/analytics/scout/${deviceId}/clock`} icon={<ClockIcon />}>
            Clock analytics
          </RouteButton>
          <DisabledText>Collection</DisabledText>
          <Button
            size="small"
            variant={clockAnalyticsActive ? "primary" : "default"}
            disabled={!jwtToken}
            onClick={() => setCollection(true)}
          >
            On
          </Button>
          <Button
            size="small"
            variant={clockAnalyticsActive === false ? "primary" : "default"}
            disabled={!jwtToken}
            onClick={() => setCollection(false)}
          >
            Off
          </Button>
        </Inline>
        <RouteButton to={`/analytics/scout/${deviceId}/battery`} icon={<BoltIcon />}>
          Battery analytics
        </RouteButton>
        <RouteButton to={`/analytics/scout/${deviceId}/responseProcessingAnalytics`} icon={<BarChartIcon />}>
          Processing/response times
        </RouteButton>
      </Stack>
    </Card>
  );
};

export default DeviceAnalytics;
